/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_5ce29654"]'><cube-slider :min="(50)" :max="(200)" :show-value="(true)" @change='(e)=>__invoke(e, [["handleChange"]])' @changing='(e)=>__invoke(e, [["handleChanging"]])'></cube-slider></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_5ce29654"}'/>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_5ce29654"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_5ce29654"}
  /** script content **/
  require("./slider-min-max.mpx.js?isComponent&outputPath=components%2Fslider-min-max5ce29654%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./slider-min-max.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fslider-min-max5ce29654%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_5ce29654"],
    ctorType: "component",
    outputPath: "components/slider-min-max5ce29654/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-slider':getComponent(require("../../../packages/mpx-cube-ui/src/components/slider/index.mpx?isComponent&outputPath=components%2Findex999434b0%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>